module.exports = __webpack_public_path__ + "assets/img/tool_zip.6b68fa05.png";